import { clsx } from 'clsx';
import { FC } from 'react';

import { IconCaretRightFilters } from 'src/general/Icons/IconCaretRightFilters';

import styles from './Chevron.module.scss';

export const Chevron: FC = () => (
  <span className={clsx(styles.root, 'chevron')}>
    <IconCaretRightFilters />
  </span>
);
